export class MatDialogMock {
  open() {}

  afterClosed() {
    return null;
  }

  closeAll() {}
}
